import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fourByFourFilled"
const FourByFourFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.313 13.875C8.452 13.875 9.375 14.798 9.375 15.938 9.375 17.077 8.452 18 7.313 18 6.173 18 5.25 17.077 5.25 15.938 5.25 14.798 6.173 13.875 7.313 13.875M17.438 13.875C18.577 13.875 19.5 14.798 19.5 15.938 19.5 17.077 18.577 18 17.438 18 16.298 18 15.375 17.077 15.375 15.938 15.375 14.798 16.298 13.875 17.438 13.875" />
          <path
            fillRule="evenodd"
            d="M12.924 5.438C13.238 5.438 13.531 5.594 13.704 5.855L15.71 8.863 20.918 9.783C21.724 9.924 22.313 10.624 22.313 11.443V12.562H21.75C21.44 12.563 21.188 12.815 21.188 13.126S21.439 13.688 21.75 13.688H22.313V15C22.313 15.518 21.893 15.938 21.375 15.938H20.25C20.25 14.384 18.99 13.125 17.438 13.125 15.884 13.125 14.625 14.385 14.625 15.938H10.125C10.125 14.384 8.865 13.125 7.313 13.125 5.759 13.125 4.5 14.385 4.5 15.938H4.125C3.607 15.938 3.188 15.518 3.188 15V12.938H4.125C4.435 12.938 4.688 12.686 4.688 12.375S4.436 11.813 4.125 11.813H3.188V9.633L3.234 9.528 3.884 8.027 3.887 8.017 3.893 8.006 4.873 5.968 4.939 5.853C5.112 5.596 5.403 5.438 5.718 5.438zM10.688 9.468 11.812 10.314H13.643L14.651 9.303 12.824 6.563H10.688zM4.916 8.474 4.606 9.187H9.564V6.563H5.835z"
            clipRule="evenodd"
          />
          <path d="M2.25 8.063C2.56 8.063 2.813 8.314 2.813 8.625V12C2.813 12.31 2.56 12.563 2.25 12.563S1.688 12.31 1.688 12V8.625C1.688 8.315 1.939 8.063 2.25 8.063" />
        </svg>
      }
    </span>
  )
}
export default FourByFourFilledIcon
